<template>
  <div id="suppliers" class="px-4 py-4">
    <div class="d-flex justify-end mb-2">
      <v-btn
        tile
        color="primary"
        @click="$router.push({ name: 'shipmentprofile-create' })"
      >
        <v-icon left>
          add_circle
        </v-icon>
        Add
      </v-btn>
    </div>
    <shipment-profile-list />
  </div>
</template>
<script>
import ShipmentProfileList from "@/components/shipment_profile_management/ShipmentProfileList.vue";
export default {
  components: {
    ShipmentProfileList
  }
};
</script>
